import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core";
import React, { useState } from "react";

interface ConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  title: string;
  isLoading?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onConfirm,
  onClose,
  title,
  isLoading = false,
}) => {
  const [processing, setProcessing] = useState(false);

  const handleConfirm = async () => {
    setProcessing(true);
    try {
      await onConfirm();
    } catch (error) {
      console.error("Error in confirm action:", error);
    } finally {
      setProcessing(false);
    }
  };

  const isButtonLoading = isLoading || processing;

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={isButtonLoading ? undefined : onClose}
        aria-labelledby="confirm-dialog-title"
      >
        <DialogTitle aria-labelledby="confirm-dialog-title">
          {title}
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={() => onClose()}
            color="primary"
            disabled={isButtonLoading}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={handleConfirm}
            disabled={isButtonLoading}
            startIcon={
              isButtonLoading ? <CircularProgress size={20} /> : undefined
            }
          >
            {isButtonLoading ? "Eliminando..." : "Eliminar"}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
